import { render, staticRenderFns } from "./EstimageMessageListView.vue?vue&type=template&id=5e80f0a4&scoped=true"
import script from "./EstimageMessageListView.vue?vue&type=script&lang=js"
export * from "./EstimageMessageListView.vue?vue&type=script&lang=js"
import style0 from "./EstimageMessageListView.vue?vue&type=style&index=0&id=5e80f0a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80f0a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e80f0a4')) {
      api.createRecord('5e80f0a4', component.options)
    } else {
      api.reload('5e80f0a4', component.options)
    }
    module.hot.accept("./EstimageMessageListView.vue?vue&type=template&id=5e80f0a4&scoped=true", function () {
      api.rerender('5e80f0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageListView.vue"
export default component.exports